import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, pn, UpdateIconButton } from "@compass/core";
import { ListBeProperty } from "components";
import { Permission, PermissionAction, SortObject, StaffPositionListDto, StaffPositionListResource } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { staffPositionPageRoute } from "../StaffPositionPage/StaffPositionPage";

export const StaffPositionTable = (props: {
    rootPermission: Permission;
    tableContainerRef: React.RefObject<HTMLDivElement>;
    staffPositions: StaffPositionListDto[];
    resource: StaffPositionListResource;
    searchFocused: boolean;
    sortObjects: SortObject[] | undefined;
    sort: (sortObjects: SortObject[]) => void;
}) => {
    const navigate = useNavigate();
    const properties = props.resource.properties || [];

    return (
        <TableContainer ref={props.tableContainerRef}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: "7%"}}>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<StaffPositionListDto>("id"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<StaffPositionListDto>("name"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell type="action" />
                    </TableRow>
                </TableHead>

                <TableBody>
                    {props.staffPositions.map((staffPositionItem) => (
                        <TableRow
                            key={staffPositionItem.id}
                            hover
                            onClick={() =>
                                navigate(
                                    staffPositionPageRoute.getPath({
                                        id: staffPositionItem.id,
                                        crudMode: "view",
                                        screenType: "dialog"
                                    })
                                )
                            }
                        >
                            <TableCell>{staffPositionItem.id}</TableCell>
                            <TableCell>{staffPositionItem.name}</TableCell>
                            <TableCell type="action">
                                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                                    <UpdateIconButton color="primary"
                                        onClick={() =>
                                            navigate(
                                                staffPositionPageRoute.getPath({
                                                    id: staffPositionItem.id,
                                                    crudMode: "edit",
                                                    screenType: "dialog"
                                                })
                                            )
                                        }
                                    />
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};